module.exports = __webpack_public_path__ + "img/118001.610a375.png";